import type { Entity as CurriculumEntity } from '@mathflat/domain/@entities/Curriculum/dto'
import type { MathflatApi } from '@mathflat/domain/@entities/Lecture/api'
import type { Entity as LectureEntity } from '@mathflat/domain/@entities/Lecture/dto'
import type { StudentDomain } from '@mathflat/domain/@entities/Student/domain.ts'
import type { StudentLectureDtoT } from '@mathflat/domain/@entities/StudentLecture'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '../utils/maxios'

export const lectureApi = {
  getLectureByTrieKey: async (trieKey: CurriculumEntity.TrieKey) => {
    const { data } = await maxios.get<DefaultResponse<MathflatApi.Response.LectureByTrieKey[]>>(
      '/lecture/group',
      {
        params: { curriculumKey: trieKey },
      },
    )
    return data.map(({ middleChapterLectures, curriculum }) => ({
      leadingCurriculum: curriculum,
      middleChapterLectures,
    }))
  },
  getDoneLectureIdByTrieKey: async (params: {
    studentId: StudentDomain.Id
    trieKey: CurriculumEntity.TrieKey
  }) => {
    const {
      data: { lectureIds },
    } = await maxios.get<DefaultResponse<MathflatApi.Response.StudentLecture>>(
      `/student-lecture/${params.studentId}`,
      {
        params,
      },
    )
    return lectureIds
  },
  getLectureByLectureId: async (lectureId: LectureEntity.Lecture['id']) => {
    const { data } = await maxios.get<DefaultResponse<MathflatApi.Response.Lecture>>(
      `/lecture/${lectureId}`,
    )
    return data
  },
  postStudentLecture: async (params: {
    studentId: StudentDomain.Id
    lectureId: LectureEntity.Lecture['id']
    assignmentId?: StudentLectureDtoT.AssignmentResponse['assignmentId']
  }) => {
    return await maxios.post('student-lecture', params)
  },
  postStudentLectureAssignmentStatus: async (params: {
    assignmentId: StudentLectureDtoT.AssignmentResponse['assignmentId']
  }) => {
    return await maxios.post(`/student-lecture/assignments/${params.assignmentId}/complete`)
  },
}
